export const TRADEME_CORE_UI_COMPACT_MAX_WIDTH = '(max-width: 768px)';
export const ERROR_TITLE = 'You’ve missed some things';
export const REQUIRED_FIELD_ERROR_MESSAGE =
    'Please fill in the required fields.';
export const SAME_PHOTO_ATTACHED_ERROR_MESSAGE = 'You have the same photo attached more than once';

